export const FILTERS_ORDER_SETTINGS_KEY_VERSION_SUBMODULES = "version-submodules";

export const NO_STICKY_RIGHT = () => false;
